import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games and get 10% off, add 3 games and get 20% off, add 4 or more games or and get 30% off or add 5+ games for 40% off your tickets!",
  progressBarAditionalText: " to continue and receive 10% off!",
};

export function MemphisBirdsLink() {
  return (
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://mlb.tickets.com/?agency=MRDM_MYTIXX&orgid=56790"
    >
      MyTickets
    </Link>
  );
}

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Memphis Redbirds account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <MemphisBirdsLink /> account within 24
        hours of purchase. Reach out to Live Fan Support or Memphis Redbirds at{" "}
        <Link
          target="_blank"
          href="tel:9017216000"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (901) 721-6000
        </Link>{" "}
        or{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="mailto:tickets@memphisredbirds.com"
        >
          tickets@memphisredbirds.com
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Memphis Redbirds Flex Plan work?",
    description:
      "The Memphis Redbirds Flex Plan allows fans to select any seat to select games hosted by the Memphis Redbirds. The more games you select the greater the discount on tickets! Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available Box Seat inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Memphis Redbirds{" "}
        <MemphisBirdsLink /> Account.
      </>
    ),
  },
];
